import type { AnimationTransform } from './animation-types.ts'

/** @internal */
export function getBaseAnimationTransform(): AnimationTransform {
    return {
        scaleX: 1,
        scaleY: 1,
        skewX: 0,
        skewY: 0,
        translateX: 0,
        translateY: 0,
    }
}

/** @internal */
export function animationTransformToStr(txs: AnimationTransform) {
    return `matrix(${txs.scaleX}, ${txs.skewY}, ${txs.skewX}, ${txs.scaleY}, ${txs.translateX}, ${txs.translateY})`
}

/** @internal */
export function strToAnimationTransform(str: string): AnimationTransform {
    const matches = str.match(
        /matrix\((?<scaleX>-?[0-9.]+),\s?(?<skewY>-?[0-9.]+),\s?(?<skewX>-?[0-9.]+),\s?(?<scaleY>-?[0-9.]+),\s?(?<translateX>-?[0-9.]+),\s?(?<translateY>-?[0-9.]+)\)/,
    )

    try {
        return {
            scaleX: parseInt(matches!.groups!.scaleX),
            scaleY: parseInt(matches!.groups!.scaleY),
            skewX: parseInt(matches!.groups!.skewX),
            skewY: parseInt(matches!.groups!.skewY),
            translateX: parseInt(matches!.groups!.translateX),
            translateY: parseInt(matches!.groups!.translateY),
        }
    } catch {
        return getBaseAnimationTransform()
    }
}
